import { getReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/city");
export var getAllCities = function getAllCities(params) {
  return getReq(BASE_URL, {
    params: params
  });
};